import { PaginationMode } from "../enums/pagination-mode.enum";

export interface PaginationConfig {
    mode: PaginationMode;
    enabled: boolean;
    startPage: number;
    defaultPageSize: number;
    availablePageSizes: number[];
}

export const DefaultPaginationConfiguration: PaginationConfig  = {
  mode: PaginationMode.Client,
  enabled: false,
  startPage: 1,
  defaultPageSize: 25,
  availablePageSizes: [25, 50, 100]
};
